/* Linda's Look – Category template behaviour (ll-* sections). Safe to load more than once. */
(function () {
  if (window.__llCollectionInit) return;
  window.__llCollectionInit = true;

  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key) || 'null');
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }

  /* ---------------- Swatches: switch variant + image ---------------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.ll-swatch[data-variant-id]');
    if (!sw) return;
    var card = sw.closest('[data-ll-card]');
    if (!card) return;
    card.querySelectorAll('.ll-swatch').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    sw.setAttribute('aria-pressed', 'true');
    var img = card.querySelector('.ll-card__img--1');
    if (img && sw.dataset.img) { img.removeAttribute('srcset'); img.src = sw.dataset.img; }
    var form = card.querySelector('[data-ll-quick-add]');
    if (form) {
      form.querySelector('[name="id"]').value = sw.dataset.variantId;
      var btn = form.querySelector('button');
      var available = sw.dataset.available === 'true';
      btn.disabled = !available;
      var t = btn.querySelector('[data-ll-btn-text]');
      if (t) t.textContent = available ? btn.dataset.label : btn.dataset.soldout;
    }
  });

  /* ---------------- Quick add (works with Horizon cart drawer + bubble) ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ll-quick-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var txt = btn.querySelector('[data-ll-btn-text]');
    var section = form.closest('[data-ll-after-add]');
    var afterAdd = section ? section.dataset.llAfterAdd : 'drawer';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    var sectionIds = [];
    document.querySelectorAll('cart-items-component[data-section-id], [data-ll-cart-section]').forEach(function (el) {
      var sid = el.dataset.sectionId || el.dataset.llCartSection;
      if (sid && sectionIds.indexOf(sid) === -1) sectionIds.push(sid);
    });

    var body = { items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }] };
    if (sectionIds.length) body.sections = sectionIds.slice(0, 5).join(',');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (added) {
        if (afterAdd === 'cart') { window.location.href = root + 'cart'; return; }
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var ev = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: form.id || 'll-quick-add',
              data: { source: 'll-quick-add', itemCount: cart.item_count, variantId: String(body.items[0].id), sections: added.sections || {} }
            }
          });
          document.dispatchEvent(ev);
          document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
          if (afterAdd === 'drawer') {
            var drawer = document.querySelector('cart-drawer-component');
            if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('auto-open')) drawer.open();
          }
          if (txt) {
            txt.textContent = btn.dataset.added;
            setTimeout(function () { txt.textContent = btn.dataset.label; }, 1800);
          }
        });
      })
      .catch(function (err) {
        if (txt) {
          txt.textContent = (err && (err.description || err.message)) || 'Error';
          setTimeout(function () { txt.textContent = btn.dataset.label; }, 2500);
        }
      })
      .finally(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
  });

  /* ---------------- Wishlist heart (local; apps can listen for "ll:wishlist") ---------------- */
  function paintWishes(scope) {
    var list = store('ll-wishlist') || [];
    (scope || document).querySelectorAll('[data-ll-wish]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.dataset.llWish) > -1 ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ll-wish]');
    if (!b) return;
    e.preventDefault();
    var list = store('ll-wishlist') || [];
    var h = b.dataset.llWish, i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.push(h);
    store('ll-wishlist', list);
    paintWishes();
    document.dispatchEvent(new CustomEvent('ll:wishlist', { detail: { handle: h, saved: i === -1, list: list } }));
  });

  /* ---------------- Collection grid: AJAX filters, sort, density, drawer ---------------- */
  function gridSection(el) { return el.closest('[data-ll-grid]'); }

  function buildParams(sec) {
    var form = sec.querySelector('[data-ll-filter-form]');
    var params = new URLSearchParams();
    if (form) {
      new FormData(form).forEach(function (v, k) { if (k.indexOf('ll-') !== 0 && String(v).trim() !== '') params.append(k, v); });
    }
    var sort = sec.querySelector('[data-ll-sort]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    var view = new URLSearchParams(window.location.search).get('view');
    if (view) params.set('view', view);
    return params;
  }

  function loadGrid(sec, url, push) {
    var id = sec.dataset.sectionId;
    var target = sec.querySelector('[data-ll-grid-root]');
    sec.classList.add('is-loading');
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', id);
    fetch(u.toString())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-ll-grid-root]');
        var openState = {};
        sec.querySelectorAll('[data-ll-filter-key]').forEach(function (d) { openState[d.dataset.llFilterKey] = d.open; });
        var scrollBox = sec.querySelector('.ll-filters');
        var scrollTop = scrollBox ? scrollBox.scrollTop : 0;
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        sec.querySelectorAll('[data-ll-filter-key]').forEach(function (d) {
          if (openState.hasOwnProperty(d.dataset.llFilterKey)) d.open = openState[d.dataset.llFilterKey];
        });
        var newBox = sec.querySelector('.ll-filters');
        if (newBox) newBox.scrollTop = scrollTop;
        u.searchParams.delete('section_id');
        if (push) history.pushState({ ll: true }, '', u.pathname + (u.search ? u.search : ''));
        paintWishes(sec);
        applyDensity(sec);
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { sec.classList.remove('is-loading'); });
  }

  var debounceT;
  document.addEventListener('change', function (e) {
    var sec = gridSection(e.target);
    if (!sec) return;
    if (e.target.matches('[data-ll-price-bucket]')) {
      var form = sec.querySelector('[data-ll-filter-form]');
      var min = form.querySelector('[data-ll-price-min]');
      var max = form.querySelector('[data-ll-price-max]');
      if (min) min.value = e.target.dataset.min || '';
      if (max) max.value = e.target.dataset.max || '';
    }
    if (e.target.closest('[data-ll-filter-form]') || e.target.matches('[data-ll-sort]')) {
      clearTimeout(debounceT);
      debounceT = setTimeout(function () {
        var p = buildParams(sec);
        loadGrid(sec, window.location.pathname + (p.toString() ? '?' + p.toString() : ''), true);
      }, e.target.type === 'number' ? 600 : 50);
    }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-ll-filter-form]');
    if (!f) return;
    e.preventDefault();
    var sec = gridSection(f);
    var p = buildParams(sec);
    loadGrid(sec, window.location.pathname + (p.toString() ? '?' + p.toString() : ''), true);
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ll-ajax-link]');
    if (a) {
      var sec = gridSection(a);
      if (sec) {
        e.preventDefault();
        loadGrid(sec, a.getAttribute('href'), true);
        if (a.hasAttribute('data-ll-scroll-top')) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
    var open = e.target.closest('[data-ll-filters-open]');
    if (open) { var s1 = gridSection(open); s1.classList.add('filters-open'); document.documentElement.style.overflow = 'hidden'; return; }
    var close = e.target.closest('[data-ll-filters-close]');
    if (close) { var s2 = gridSection(close); s2.classList.remove('filters-open'); document.documentElement.style.overflow = ''; return; }
    var dens = e.target.closest('[data-ll-density]');
    if (dens) {
      var s3 = gridSection(dens);
      store('ll-density-' + (window.innerWidth < 750 ? 'm' : 'd'), dens.dataset.llDensity);
      applyDensity(s3);
    }
  });

  function applyDensity(sec) {
    var mobile = window.innerWidth < 750;
    var saved = store('ll-density-' + (mobile ? 'm' : 'd'));
    var grid = sec.querySelector('.ll-grid__products');
    if (!grid) return;
    grid.classList.toggle('is-dense', saved === 'dense');
    sec.querySelectorAll('[data-ll-density]').forEach(function (b) {
      b.setAttribute('aria-pressed', (b.dataset.llDensity === (saved || 'default')) ? 'true' : 'false');
    });
  }

  window.addEventListener('popstate', function () {
    document.querySelectorAll('[data-ll-grid]').forEach(function (sec) { loadGrid(sec, window.location.href, false); });
  });

  /* ---------------- Carousels: arrow buttons ---------------- */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-ll-scroll]');
    if (!arrow) return;
    var track = arrow.closest('.ll-section').querySelector('.ll-scroller');
    if (!track) return;
    var dir = arrow.dataset.llScroll === 'prev' ? -1 : 1;
    track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
  });

  function init(scope) {
    paintWishes(scope);
    (scope || document).querySelectorAll('[data-ll-grid]').forEach(applyDensity);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
